import {EventEmitter, Injectable} from '@angular/core';
import {ToastModel} from '@syncfusion/ej2-notifications';

@Injectable({
  providedIn: 'root',
})
export class NotificationToastService {
  notificationToastEvent = new EventEmitter<ToastModel>();

  push(toast: ToastModel) {
    return this.notificationToastEvent.next(toast);
  }

  constructor() {}
}
